module.exports = __webpack_public_path__ + "static/cherished-objects-logo-b343f02534dc58bbca8a0c40eb7c2e01.svg";